import { useCallback, useEffect } from 'react';
import { isSome } from 'fp-ts/lib/Option';

import Widget from 'domain/entity/widget';
import { ReadWidgetsCriteriaBuilder } from 'use-case/widgets/read/readWidgetsCriteria';
import { DefaultUseCaseState } from 'adapter/in/common/hooks/useCase';
import { useWidgets } from 'adapter/in/dashboards/context/Widgets/data';
import { dispatchWidgetsView, useWidgetsView } from 'adapter/in/dashboards/context/Widgets/view';

export const useReadWidgets = (dashboardId: string): DefaultUseCaseState<Widget[]> & { success: boolean; reset: () => void } => {
    const { readIsLoading, readResult, readError, read, readReset } = useWidgets();
    const { reloadingWidgets } = useWidgetsView();
    const { toggleReloadWidgets } = dispatchWidgetsView();

    const handleRead = useCallback(() => {
        read(ReadWidgetsCriteriaBuilder.create().withDashboardId(dashboardId).build());
    }, [dashboardId]);

    useEffect(() => {
        handleRead();
    }, [dashboardId]);

    useEffect(() => {
        if (reloadingWidgets === true) {
            handleRead();
        }
    }, [reloadingWidgets]);

    useEffect(() => {
        if (isSome(readResult)) {
            toggleReloadWidgets(false);
        }
    }, [readResult]);

    return {
        success: !!isSome(readResult),
        isLoading: readIsLoading,
        data: readResult,
        error: readError,
        reset: readReset,
    };
};
